import React, { Component } from 'react'
import PropTypes from 'prop-types'

import classnames from 'classnames'

import {
  inputPropType,
  numberType,
  unit,
  unitType,
} from '../propTypes'

import { unitMap, unitOptions } from '../utils'

import Input from './Input'
import Toggle from './Toggle'
import Total from './Total'

export default class CalculationGroup extends Component {
  static propTypes = {
    average: PropTypes.number,
    averageLabel: PropTypes.node,
    averageType: numberType,
    field: PropTypes.string.isRequired,
    info: PropTypes.node,
    input: PropTypes.shape(inputPropType),
    label: PropTypes.string.isRequired,
    onChange: PropTypes.func,
    readOnly: PropTypes.bool,
    total: PropTypes.number,
    totalLabel: PropTypes.node,
    totalType: numberType,
    unit,
    unitType,
    value: PropTypes.number,
  }

  static defaultProps = {
    averageLabel: 'Average per dwelling',
    averageType: 'currency',
    totalLabel: 'Total',
    totalType: 'currency',
  }

  state = {
    infoOpen: false,
  }

  handleValueChanged = (value) => {
    if (this.props.unitType) {
      this.props.onChange({ value, unit: this.props.unit })
    } else {
      this.props.onChange(value)
    }
  }

  handleUnitChanged = (unit) => {
    this.props.onChange({ value: this.props.value, unit })
  }

  toggleInfoOpen = () => this.setState({ infoOpen: ! this.state.infoOpen })

  render() {
    const {
      average,
      averageLabel,
      averageType,
      field,
      input,
      label,
      info,
      readOnly,
      total,
      totalLabel,
      totalType,
      unit,
      unitType,
      value,
    } = this.props

    const { infoOpen } = this.state

    let inputPrefix = input && input.prefix
    let inputSuffix = input && input.suffix

    if (! inputPrefix) {
      if (unitType && unit === 'fixed') {
        inputPrefix = unitMap[unit]
      }
    }

    if (! inputSuffix) {
      if (unitType && unit !== 'fixed') {
        inputSuffix = unitMap[unit]
      }
    }

    const infoButtonClasses = classnames([
      'form-label__help-trigger',
      infoOpen && 'form-label__help-trigger--active',
    ])

    const infoHelpClasses = classnames([
      'form__help-text',
      infoOpen && 'form__help-text--active',
    ])

    return (
      <div className={`calculation-group ${readOnly ? 'calculation-group--read-only' : ''}`}>
        <label className='form__label form-label' htmlFor={field}>
          {label}
          {info && (
            <button
              className={infoButtonClasses}
              onClick={this.toggleInfoOpen}
              title='Show/hide more info'
              type='button'
            >
              <span>i</span>
            </button>
          )}
        </label>
        <div className='calculation-group__input calculation-input'>
          <div className='form__group'>
            <Input
              {...input}
              field={field}
              onChange={readOnly ? null : this.handleValueChanged}
              prefix={inputPrefix}
              readOnly={readOnly}
              suffix={inputSuffix}
              value={value}
            />
          </div>

          {unitType && (! readOnly) && (
            <Toggle
              onChange={this.handleUnitChanged}
              options={unitOptions[unitType]}
              value={unit}
            />
          )}
        </div>

        {((total || average) != null) ? (
          <div className='calculation-group__results calculation-results'>
            {<Total label={averageLabel} type={averageType} unit={unit} value={average} />}
            {<Total label={totalLabel} type={totalType} unit={unit} value={total} />}
          </div>
        ) : null}

        {info && <div className={infoHelpClasses}>{info}</div>}
      </div>
    )
  }
}
